
define('tpl!taoQtiItem/qtiCommonRenderer/tpl/interactions/associateInteraction.pair', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, self=this;

function program1(depth0,data) {
  
  
  return "incomplete-pair";
  }

  buffer += "<li class=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.empty), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n    <div class=\"target lft\"></div>\n    <div class=\"target rgt\"></div>\n</li>\n";
  return buffer;
  });
});

